export default __webpack_public_path__ + "static/media/cart_img.15c167ed.svg";